import { DOMRouteHandler } from './DOMRouteHandler';
import { initPreactivationUpgradeInput } from '../modules/preactivationUpgrade';
import { notifyHandledException } from '../utils/errorLogger';

export class TemplateProductUpgPreactivation extends DOMRouteHandler {
  static init(): void {
    try {
      initPreactivationUpgradeInput();
    } catch (e) {
      if (e instanceof Error) {
        notifyHandledException(e);
      }
    }
  }
}
